/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {RootScopeService} from "./rootscope.service";
import {TranslateService} from "@ngx-translate/core";
import {SessionService} from "./session.service";

@Injectable({
    providedIn: 'root'
})
export class CertificateService {

    private link: any;

    constructor(private rootScope: RootScopeService, private translateService: TranslateService, private sessionService: SessionService) {
    }

    createGcsLink(): any {
        var languageToUse;

        if (this.translateService.currentLang && this.rootScope.get().properties.gcsUrls.hasOwnProperty(this.translateService.currentLang)) {
            languageToUse = this.translateService.currentLang;
        } else if (this.sessionService.info.configDto.defaultLocale && this.rootScope.get().properties.gcsUrls.hasOwnProperty(this.sessionService.info.configDto.defaultLocale)) {
            languageToUse = this.sessionService.info.configDto.defaultLocale;
        } else {
            languageToUse = this.rootScope.get().properties.defaultLanguage;
        }
        this.link = this.rootScope.get().properties.gcsUrls[languageToUse];

        return this.link

    }

}
